import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsTpamsConstants } from "./view-application-details-tpams.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { TownplanningService } from "../../../../../shared/services/modules/townplanning.service";
let ViewApplicationDetailsTpamsComponent = class ViewApplicationDetailsTpamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    townplanningService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsTpamsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = ViewApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = ViewApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsTpamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addApplicationTypeLabel = ViewApplicationDetailsTpamsConstants.ADD_APPLICATION_TYPE_LABEL;
    addZoneLabel = ViewApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsTpamsConstants.REFERENCE_NUMBER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = ViewApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = ViewApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    applicationTypes = [];
    zones = [];
    saveBtnPlaceholder = ViewApplicationDetailsTpamsConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    rezoneConfirmationControlName = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME;
    rezoneConfirmationLabel = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_LABEL;
    rezoneKeywordRezone = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONE;
    rezoneKeywordRezoning = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONING;
    isRezoning = false;
    applicationTypesControl;
    getApplicationSaveObservableSubscription;
    getApplicationSetZonesObservableSubscription;
    getApplicationSetApplicationTypesObservableSubscription;
    constructor(aflaModuleStrategyService, townplanningService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.townplanningService = townplanningService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    getApplication() {
        const params = {
            $expand: `applicationTypes,applicationZonings`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe((response) => this.onGetApplicationCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    getZones() {
        return this.detailsForm.get("zones");
    }
    onBtnRemoveZoneClicked(i) {
        const zoneControls = this.getZones();
        if (zoneControls.controls.length > 1) {
            zoneControls.removeAt(i);
        }
    }
    onBtnAddApplicationTypeClicked() {
        const applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            type: new FormControl(null, [Validators.required])
        });
        applicationTypesControl.push(typeGroup);
    }
    onBtnAddZoneClicked() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            applicationPropertyId: new FormControl(0),
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const app = {
                amendmentSchemeNumber: this.detailsForm.get(this.amendmentSchemeNumberFormControlName).value,
            };
            const zoneParams = {
                zones: []
            };
            const zoneControls = this.getZones();
            zoneControls.controls.forEach(zoneControl => {
                const zone = {
                    id: zoneControl.get("id").value,
                    applicationId: zoneControl.get("applicationId").value,
                    applicationPropertyId: zoneControl.get("applicationPropertyId").value,
                    zoning: zoneControl.get("zone").value.value,
                    deleted: false,
                };
                zoneParams.zones.push(zone);
            });
            const typeParams = {
                types: []
            };
            const typeControls = this.getApplicationTypes();
            typeControls.controls.forEach(typeControl => {
                const type = {
                    id: typeControl.get("id").value,
                    applicationId: typeControl.get("applicationId").value,
                    applicationType: typeControl.get("type").value.value,
                    deleted: false
                };
                typeParams.types.push(type);
            });
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                    .subscribe(appSaveresponse => {
                    this.setZones(zoneParams, typeParams);
                }, error => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.amendmentSchemeNumberFormControlName).setValue(application.amendmentSchemeNumber);
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            const typesControl = this.getApplicationTypes();
            typesControl.clear();
            application.applicationTypes.forEach(applicationType => {
                let appType = null;
                this.applicationTypes.forEach(item => {
                    if (item.value === applicationType.applicationType) {
                        appType = item;
                        if (item.value.toLowerCase().includes(this.rezoneKeywordRezone) ||
                            item.value.toLowerCase().includes(this.rezoneKeywordRezoning)) {
                            this.isRezoning = true;
                        }
                    }
                });
                const typeGroup = new FormGroup({
                    id: new FormControl(applicationType.id),
                    applicationId: new FormControl(applicationType.applicationId),
                    type: new FormControl(appType, [Validators.required])
                });
                typesControl.push(typeGroup);
            });
            const zonesControl = this.getZones();
            zonesControl.clear();
            application.applicationZonings.forEach(applicationZoning => {
                let zone = null;
                this.zones.forEach(item => {
                    if (item.value === applicationZoning.zoning) {
                        zone = item;
                    }
                });
                const zoneGroup = new FormGroup({
                    id: new FormControl(applicationZoning.id),
                    applicationId: new FormControl(applicationZoning.applicationId),
                    applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                    zone: new FormControl(zone, [Validators.required])
                });
                zonesControl.push(zoneGroup);
            });
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        // this.requestStatusService.showBusySpinner("gettingLookups");
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType' or name eq 'Zoning')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.getApplication();
    }
    setZones(zoneParams, typeParams) {
        this.getApplicationSetZonesObservableSubscription =
            this.townplanningService.getApplicationSetZonesObservable(this.application.id, zoneParams)
                .subscribe(addZoneesponse => {
                this.setTypes(typeParams);
            }, error => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
            });
    }
    setTypes(typeParams) {
        this.getApplicationSetApplicationTypesObservableSubscription =
            this.townplanningService.getApplicationSetApplicationTypesObservable(this.application.id, typeParams)
                .subscribe(addTypesResponse => {
                this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
            }, error => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
            });
    }
    onApplicationTypeSelected(event) {
        let match = false;
        const element = event.target;
        let selectedText = element.options[element.options.selectedIndex].text;
        const typeControls = this.getApplicationTypes();
        typeControls.controls.forEach(type => {
            if (match == false) {
                if ((type.value.type.value.toLowerCase().includes(this.rezoneKeywordRezone) ||
                    type.value.type.value.toLowerCase().includes(this.rezoneKeywordRezoning))) {
                    this.isRezoning = true;
                    match = true;
                }
                else {
                    this.isRezoning = false;
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: TownplanningService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsTpamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsTpamsComponent);
export { ViewApplicationDetailsTpamsComponent };
